import IconPersonSmall from "@amzn/stencil-react-icons/icons/icon-person-small";
import IconSettingsSmall from "@amzn/stencil-react-icons/icons/icon-settings-small";
import React from "react";

import Selfie from "@/assets/icons/selfie.svg";
import Video from "@/assets/icons/video.svg";
import { EntitlementCardProps } from "@/components/IdentityCheck/WizardPathChooser/IdentityVerificationSelectionCard";

const defaultEntitlementProps = {
  width: "407px",
};

export const RIV_ENTITLEMENT_AUTOMATED: EntitlementCardProps = {
  bodyi18nId: "identityCheck-pathchooser-card-ivv-body",
  bodyIcon: <img src={Selfie} alt="Automated face scan icon" />,
  dataTestId: "VerificationTypeCardAutomated",
  estimatedTimeToCompletionMinutes: 2,
  recommended: true,
  titlei18nId: "identityCheck-pathchooser-card-ivv-title",
  cardType: "IVV",
  verificationTypei18n:
    "identityCheck-pathchooser-card-verificationTypeAutomated",
  verificationTypeIcon: <IconSettingsSmall color="primary70" />,
  ...defaultEntitlementProps,
};

export const RIV_ENTITLEMENT_MANUAL: EntitlementCardProps = {
  bodyi18nId: "identityCheck-pathchooser-card-manual-body",
  bodyIcon: <img src={Video} alt="Record videos icon" />,
  dataTestId: "VerificationTypeCardManual",
  estimatedTimeToCompletionMinutes: 15,
  titlei18nId: "identityCheck-pathchooser-card-manual-title",
  cardType: "ManualRIV",
  verificationTypei18n: "identityCheck-pathchooser-card-verificationTypeManual",
  verificationTypeIcon: <IconPersonSmall color="neutral100" />,
  ...defaultEntitlementProps,
};
